// extracted by mini-css-extract-plugin
export default {"navitem":"NavItem_navitem__xNsR2","navactive":"NavItem_navactive__0Ms9P"};